import * as React from 'react';
import cx from 'classnames';
import { polymorphic } from '../../utils/functions/polymorphic.js';
import { Box } from '../../utils/components/index.js';
export const LinkAction = React.forwardRef((props, forwardedRef) => {
  let { as: asProp = props.href ? 'a' : 'button' } = props;
  return React.createElement(Box, {
    ...props,
    as: asProp,
    className: cx('iui-link-action', props.className),
    ref: forwardedRef,
  });
});
LinkAction.displayName = 'LinkAction';
export const LinkBox = polymorphic.div('iui-link-box');
LinkBox.displayName = 'LinkBox';
